export const ROOM_TYPES = [
  'Living Room',
  'Bedroom',
  'Kitchen',
  'Dining Room',
  'Office',
  'Bathroom',
  'Study Room',
  'Kids Room',
  'Dressing Room',
];

export const DESIGN_STYLES = [
  'Modern',
  'Scandinavian',
  'Minimal',
  'Luxury',
  'Boho',
  'Industrial',
  'Classic',
  'Japandi',
  'Farmhouse',
  'Coastal',
];
